import { createConfigContext } from 'fulogics-ui-core/dist/layout/configContext';

export type UiConfigType = {
    StateOrderSimpleText: {
        deadlineVisibleMs: number;
    };
};

export const UiConfig = {
    StateOrderSimpleText: {
        deadlineVisibleMs: 5 * 60 * 1000, // 5 min
    },
};

export const [UIConfigContext, useUIConfig] = createConfigContext<UiConfigType>(UiConfig);
